import {Inject, Optional, Pipe, PipeTransform} from '@angular/core';
import {isNullOrUndefined} from 'util';
/**
 * Rc Image Pipe
 * In App Module add to provider
 *
 * @example
 * const imagesConfig: IImagesConfig = {
 *  baseUrl: 'some base url'
 * }
 * add to app module
 * {
 *   provide: 'ImageConfig',
 *   useValue: imagesConfig
 * }
 * <img [src]="imgSrc | rcImage">
 *
 */
@Pipe({
    name: 'rcImage'
})
export class RcImagePipe implements PipeTransform {
  private config: IImagesConfig = {
    baseUrl: ''
  };

  /**
   * @param imageConfig - should be defined in the app module as provider with useValue
   */
  constructor(@Inject('ImageConfig')  @Optional() imageConfig: IImagesConfig = null) {
    if (!isNullOrUndefined(imageConfig)) {
      this.config = Object.assign({}, imageConfig);
    }
  }
  transform(value: any): any {
    if (!value) {
      return null;
    }
    return `${this.config.baseUrl}${value}`;
  }
}

export interface IImagesConfig {
  baseUrl: string;
}
